import React, { Component } from "react";
import GenericTree from "./GenericTree";
import CommonUtil from "../../../utils/CommonUtil";

class GenericTreeContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expandedKeys: []
    };
  }

  onSelect = key => {
    var expandedKeys = this.state.expandedKeys;
    if (expandedKeys.includes(key)) {
      CommonUtil.removeElementFromArray(expandedKeys, key);
    } else {
      expandedKeys.push(key);
    }
    this.onExpand(expandedKeys);
  };

  onExpand = expandedKeys => {
    this.setState({
      expandedKeys: [...expandedKeys]
    });
  };

  resetExpandedKeys = () => {
    this.setState({
      expandedKeys: []
    });
  };

  render() {
    return (
      <GenericTree
        data={this.props.data}
        loadData={this.props.loadData}
        onClick={this.props.onClick}
        pageInfo={this.props.pageInfo}
        onPageNumberClick={this.props.onPageNumberClick}
        loadedKeys={this.props.loadedKeys}
        onSelect={this.onSelect}
        expandedKeys={this.state.expandedKeys}
        onExpand={this.onExpand}
        fontAwesomeIcon={this.props.fontAwesomeIcon}
      />
    );
  }
}

export default GenericTreeContainer;
